<template>
  <div class="reference-details">
    <div
      v-if="!reference.unsubstantiated && !reference.isPrimarySource"
      class="reference-details-row"
      @click="$emit('preview', pageFromReferenceId)"
    >
      <TextBody
        tag="span"
        i18n-key="conversation.referenceCard.referenceFoundOn"
        weight="medium"
        className="subtitle"
      />
      <div>·</div>
      <TextBody tag="span" :text="reference.name" weight="medium" className="link" />
      <div>></div>
      <TextBody tag="span" :text="`p. ${pageFromReferenceId}`" weight="medium" className="link" />
    </div>

    <div
      v-for="(passage, passageIndex) in uniquePassages"
      :key="`${passage.externalId}-${passageIndex}`"
      class="reference-passage"
    >
      <div class="reference-details-row" @click="$emit('preview', passage.page)">
        <TextBody
          tag="span"
          :i18n-key="placeholder"
          :text="!placeholder ? `Passage ${passageIndex + 1}` : ''"
          weight="medium"
          className="subtitle"
        />
        <div>·</div>
        <TextBody tag="span" :text="reference.name" weight="medium" className="link" />
        <div>></div>
        <TextBody tag="span" :text="`p. ${passage.page}`" weight="medium" className="link" />
      </div>
      <span class="reference-snippet">"...{{ passage.decodedSnippet }}"</span>
      <TextBody
        tag="span"
        i18n-key="conversation.referenceCard.readFullPassage"
        weight="medium"
        className="link-top-4"
        @click="$emit('preview', passage.page)"
      />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import TextBody from '~/components/common/TextBody';

export default {
  name: 'ReferenceDetails',
  components: { TextBody },
  emits: ['preview'],
  props: {
    reference: {
      type: Object,
      default: () => ({}),
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const pageFromReferenceId = computed(() => {
      const match = (props.reference?.referenceId || '').match(/:p(\d+)/);
      return match ? Number(match[1]) + 1 : props.reference?.page ?? null;
    });

    const uniquePassages = computed(() => {
      const passages = Array.isArray(props.reference?.passages) ? props.reference.passages : [];
      const seen = new Set();

      return passages.filter((passage = {}) => {
        const key = `${passage.page ?? ''}-${passage.snippetIndex ?? ''}`;

        if (seen.has(key)) {
          return false;
        }

        seen.add(key);
        return true;
      });
    });

    return {
      pageFromReferenceId,
      uniquePassages,
    };
  },
};
</script>

<style lang="scss" scoped>
.reference-details {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-2;
  flex-wrap: wrap;

  .reference-passage {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .reference-snippet {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .reference-details-row {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #cecdcc;
  }

  :deep(.link) {
    color: $bb-primary-3 !important;
    font-size: 11px;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 250px;
  }

  :deep(.link-top-4) {
    color: $bb-primary-3 !important;
    font-size: 11px;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 250px;
    margin-top: $bb-spacing-1;
  }

  :deep(.subtitle) {
    text-transform: uppercase;
    color: #6a6765 !important;
    font-size: 10px;
    font-weight: 700 !important;
  }
}
</style>
